import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import TablePage from './TablePage.js'
import AddPage from './AddPage.js'
import EditPage from './EditPage.js'
import ViewPage from './ViewPage.js'
import SubmissionResponsePage from './SubmissionResponsePage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ABIEntrySummaryTranslationProvider from '../contexts/ABIEntrySummaryTranslationContext.js'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <TablePage showNotification={showSnackbar} {...props} />
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <AddPage showNotification={showSnackbar} {...props} />
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <EditPage showNotification={showSnackbar} {...props} />
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <ViewPage showNotification={showSnackbar} {...props} />
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}
function WrappedResponsePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ABIEntrySummaryTranslationProvider>
          <SubmissionResponsePage showNotification={showSnackbar} {...props} />
        </ABIEntrySummaryTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedResponsePage as ResponsePage,
  WrappedTablePage as TablePage
}
